import React, { useEffect, useState } from 'react';
import { StyledModal, ModalHeader, ModalTitle, ModalCloseButton } from '@/shared/components/Modal';
import { Button } from '@/shared/components/Button';
import styled from 'styled-components';
import TextField from '@/shared/components/form/Fields/TextField';
import { NumberBlock } from './NumberBlock';

const ConfirmationModal = ({ onCancel, onConfirm, title, message, confirmButtonText, variant, hardConfirmation }) => {
  const [randomNumber, setRandomNumber] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [userInput, setUserInput] = useState('');

  useEffect(() => {
    const number = Math.floor(100000 + Math.random() * 900000);
    setRandomNumber(number);
  }, []);

  useEffect(() => {
    setConfirmed(userInput === randomNumber.toString());
  }, [userInput, randomNumber]);

  const onConfirmHardConfirmation = () => {
    if (userInput === randomNumber.toString()) {
      onConfirm();
    }
  };

  return (
    <Modal
      show={true}
      color='danger'
    >
      <ModalHeader className='mb-1'>
        <ModalCloseButton
          className='lnr lnr-cross'
          aria-label='close-btn'
          type='button'
          onClick={onCancel}
        />
        <ModalTitle>{title ? title : 'Confirm Deletion'}</ModalTitle>
      </ModalHeader>
      <div>
        <p>{message ? message : 'Are you sure you want to delete?'}</p>
        {hardConfirmation && (
          <>
            <br />
            <b>Enter the number to confirm</b>
            <NumberBlock value={randomNumber} />
            {/* <br /> */}
            <div style={{ padding: '5px 35px' }}>
              <TextField
                name='text'
                label='Confirmation Number'
                placeholder='Enter the number to confirm'
                defaultValue={userInput}
                onChange={(e) => setUserInput(e.target.value)}
              />
            </div>
          </>
        )}
        {/* <br /> */}

        <br />
        {hardConfirmation ? (
          <Button
            data-testid='confirm-delete-button'
            variant={variant ? variant : 'danger'}
            disabled={!confirmed}
            onClick={onConfirmHardConfirmation}
          >
            {confirmButtonText ? confirmButtonText : 'Confirm Delete'}
          </Button>
        ) : (
          <Button
            data-testid='confirm-delete-button'
            variant={variant ? variant : 'danger'}
            onClick={onConfirm}
          >
            {confirmButtonText ? confirmButtonText : 'Confirm Delete'}
          </Button>
        )}
        <Button
          variant='secondary'
          data-testid='cancel-delete-button'
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

const Modal = styled(StyledModal)`
  .modal-dialog {
    min-width: 400px;
    box-shadow: 2px 6px 8px rgba(0, 0, 0, 0.1); /* Adjust the values as needed */
  }
`;

export default ConfirmationModal;
